export const translations = {
  buscar: {
    pt: 'Buscar',
    en: 'Search',
    de: 'Suchen',
    es: 'Búsqueda',
  },
};